import { Tooltip } from "@mui/material";
import { Grid } from "@mui/material";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import { observer } from "mobx-react";
import React from "react";
import { OrganizationUserStore } from "../../stores/OrganizationUserStore";
import {
    HierarchyPermissions,
    HierarchyTypes,
    IHierarchyAssignmentTier,
} from "./Types";
import { PERMISSION_ICONS, TYPE_ICONS } from "./Utilities";
import AcxSwitch from "components/UI/AcxSwitch";
import styled from "@emotion/styled";

const StyledSwitch = styled(AcxSwitch)(() => ({
    margin: "0 1rem 0 0.5rem",
}));

interface IHierarchyAssignmentToggleProps {
    permissionValidator: (
        hasAdminPerms: boolean,
        permission: string,
        branch: IHierarchyAssignmentTier,
    ) => boolean;
    typeValidator: (
        hasAdminPerms: boolean,
        branch: IHierarchyAssignmentTier,
    ) => boolean;
    onChangeHandler: (event: any, checked: boolean) => void;
    branch: IHierarchyAssignmentTier;
    store: OrganizationUserStore;
    hasAdminPerms: boolean;
    fullSize?: boolean;
}

const HierarchyAssignmentToggles: React.FC<
    React.PropsWithChildren<
        React.PropsWithChildren<IHierarchyAssignmentToggleProps>
    >
> = observer(
    ({
        permissionValidator,
        typeValidator,
        onChangeHandler,
        branch,
        store,
        hasAdminPerms,
        fullSize,
    }) => {
        return (
            <Grid
                container
                item
                xs={fullSize ? 12 : 9}
                rowSpacing={1}
                justifyContent="flex-end"
            >
                <Tooltip title="Toggle All">
                    <Grid
                        container
                        item
                        alignItems="center"
                        xs={2}
                        style={{ minWidth: "80px" }}
                    >
                        <AllInclusiveIcon fontSize="small" color="primary" />

                        <StyledSwitch
                            value="master"
                            id="toggle-all-switch"
                            disabled={!hasAdminPerms}
                            checked={
                                (branch.permissions?.length ?? 0) >=
                                    store.hierarchyPermissions.length &&
                                (branch.types?.length ?? 0) >=
                                    store.hierarchyTypes.length
                            }
                            onChange={onChangeHandler}
                        />
                    </Grid>
                </Tooltip>

                {store.hierarchyPermissions?.map((perm) => (
                    <Tooltip key={perm} title={perm}>
                        <Grid
                            container
                            item
                            alignItems="center"
                            xs={2}
                            style={{ minWidth: "80px" }}
                        >
                            {PERMISSION_ICONS[perm]}

                            <StyledSwitch
                                value={perm}
                                disabled={
                                    !permissionValidator(
                                        hasAdminPerms,
                                        perm,
                                        branch,
                                    )
                                }
                                checked={
                                    branch.permissions?.includes(
                                        HierarchyPermissions[perm],
                                    ) ?? false
                                }
                                onChange={onChangeHandler}
                            />
                        </Grid>
                    </Tooltip>
                ))}

                {store.hierarchyTypes?.map((type) => (
                    <Tooltip key={type} title={type}>
                        <Grid
                            container
                            item
                            alignItems="center"
                            xs={2}
                            style={{ minWidth: "80px" }}
                        >
                            {TYPE_ICONS[type]}

                            <StyledSwitch
                                value={type}
                                disabled={!typeValidator(hasAdminPerms, branch)}
                                checked={
                                    branch.types?.includes(
                                        HierarchyTypes[type],
                                    ) ?? false
                                }
                                onChange={onChangeHandler}
                            />
                        </Grid>
                    </Tooltip>
                ))}
            </Grid>
        );
    },
);

export default HierarchyAssignmentToggles;
